'use strict';

/* globals TMPlus, window */

(function (module) {
	const serializer = {};
	let XRegExp;

	if (typeof window === 'undefined') {
		XRegExp = require('xregexp');
	} else {
		XRegExp = window.XRegExp;
	}

	// eslint-disable-next-line no-useless-escape
	const tmpRegex = XRegExp('(?:(?:\\[do-not-edit-from-this-line-tmplus-session-room-settings\\])(?<json>(?:.|\\n)+)(?:\\[do-not-edit-to-this-line-tmplus-session-room-settings\\]))', 'g');
	const settingsValidators = {
		roomType: {
			test: value => value > 1 && value < 4,
			parse: value => parseInt(value, 10),
		},
		startTime: {
			test: value => parseInt(value, 10) + 14400 > Date.now() / 1000, // After 4 hours ago
			parse: value => parseInt(value, 10),
		},
		// endTime: {
		// 	test: value => parseInt(value, 10) + 14400 > Date.now() / 1000, // After 4 hours ago
		// 	parse: value => parseInt(value, 10),
		// },
		bitrate: {
			test: value => value > 1 && value < 6,
			parse: value => parseInt(value, 10),
		},
		duration: {
			test: value => value > 1,
			parse: value => parseInt(value, 10),
		},
		// sessionAudience: {
		// 	test: value => value === 'adult' || value === 'child',
		// 	parse: value => value,
		// },
		// screenShare: {
		// 	test: value => ,
		// 	parse: value => ,
		// },
	};

	serializer.hasMarkup = content => XRegExp.exec(content, tmpRegex) !== null;

	serializer.serialize = (post) => {
		const match = XRegExp.exec(post, tmpRegex);

		if (!match) { return; }

		return JSON.parse(match.json);
	};

	serializer.deserialize = room => `[do-not-edit-from-this-line-tmplus-session-room-settings]
${JSON.stringify(room)}
[do-not-edit-to-this-line-tmplus-session-room-settings]`;

	serializer.removeMarkup = (content, repalce) => {
		if (!content) { return ''; }
		return XRegExp.replace(content, tmpRegex, repalce || '');
	};

	module.exports = serializer;
	if (typeof TMPlus !== 'undefined') {
		TMPlus.serializer = serializer;
	}
}(typeof module === 'undefined' ? {
	module: { exports: {} },
} : module));
